import { Component, input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertTypes } from 'src/app/models/enums/inline-alert';

@Component({
    selector: 'app-modal-icons',
    templateUrl: './modal-icons.component.html',
    styleUrls: ['./modal-icons.component.scss']
})
export class ModalIconsComponent {
    public readonly iconType = input<AlertTypes>(undefined);
    public AlertTypes = AlertTypes;


    constructor(
        public activeModal: NgbActiveModal,
    ) { }

}
